import { useRef, useEffect } from 'react'
import range from 'lodash/range'

export default function VisibilityObserver(props) {
  const pagesContainer = useRef(null)
  const observer = useRef(null)

  useEffect(() => {
    pagesContainer.current = document.querySelector('.Pages')

    if (window.IntersectionObserver) {
      const threshold = range(0, 1.1, 0.1).map((number) => Math.round(number * 10) / 10)
      observer.current = new window.IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            props.onVisibilityChange(entry.intersectionRatio)
          })
        },
        {
          root: pagesContainer.current,
          threshold,
        },
      )
      observer.current.observe(props.pageDiv)
    }
    return () => {
      if (observer.current && observer.current.unobserve) {
        observer.current.unobserve(props.pageDiv)
      }
      delete pagesContainer.current
    }
  }, [])

  return null
}
